<template>
  <v-container id="bid-summary" data-cy="bid-summary" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <idc-component-bid-summary :type="status" :statuses="bidStatuses" :can-submit-bid="canSubmitBid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { ManagementStatus } from '@/utilities/bid/enums/Status'

  export default Vue.extend({
    name: 'DashboardBidSummary',
    components: {
      IdcComponentBidSummary: () => import('@/components/idc/bids/Summary'),
    },
    props: {
      canSubmitBid: {
        type: Boolean,
        default: () => false,
      },
      bidStatuses: {
        type: Array,
        default: () => [1, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      },
    },
    data: () => ({
      status: ManagementStatus.STATUS_TYPE_BID,
    }),
  })
</script>

<style lang="sass">
  section#bid-summary
    .v-card--material
      &__heading.success
        background-color: $dark-red-colour !important
        border-color: $dark-red-colour !important
</style>
